import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="loading-screen">
      <img src="/assets/ccvellore.png" alt="loading" />
    </div>
  );
};

export default Loading;
